import optionsAi from "./climaai.json"



const testRendering = (item, data) =>{
    //props are in OR
    if (item.notCondo === true){
        if (data["C11"] !=="Monofamiliare" && data["C11"] !=="Bifamiliare") return false
    }
    if (!item.conditionalRendering) return true;
    if (item.conditionalRendering.cell?.includes("process.env.")){
        const env = item.conditionalRendering.cell?.split("process.env.")[1]
        return process.env[env] === item.conditionalRendering.value
    }
    // if (item.text === "Piano Cottura Cibi"){
    //     debugger;
    //     console.log(item)
    // }
    if (item.cell === "EV")
        console.log(item.conditionalRendering, data[item.conditionalRendering.cell], data[item.conditionalRendering.cell] === item.conditionalRendering.value)
    
    for (let i = 0; i < item.conditionalRendering.length; i++) {
       
        const element = item.conditionalRendering[i];
        if (element.cell?.includes("process.env.")){
            const env = element.cell?.split("process.env.")[1]
            if (process.env[env] !== element.value)
                return false;
        }

        if (element.operator === "must" && data[element.cell] !== element.value) return false;
        if (element.operator === "notin" && !element.value.includes(data[element.cell])) return false;
        if (element.operator === "notequal" && data[element.cell] !== element.value) return true;
        if (element.operator === "equal" && data[element.cell] === element.value) return true;
        if (element.operator === "isPresent" && data[element.cell]) return !!data[element.cell];
        if (element.operator === "isNotPresent" && data[element.cell]) return !data[element.cell];
    }
    return false
}

const sendFoto = (data) =>{
    const non = (val) => {
        return val === undefined || val === "No" || val === false || val === null
    }

    return ((data["C11"] === "Monofamiliare" || data["C11"] === "Bifamiliare")
            && non(data["C45"]) && non(data["C41"]) 
            && non(data["Final_TV"]) && non(data["Final_Frigorifero"])
            && non(data["Final_Lavatrice"]) && non(data["Final_Asciugatrice"])
            && non(data["C48"]) && (data["C53"] === true || data["C53"] === "Si"))
}

// const checkIfProjectIsComplete = async (id) => { 
//     const response = await fetch(`https://greenovationdashboard.azurewebsites.net/api/enelcore/?id=${id}`, {
//         method: "GET",
//         headers: {
//             "Content-Type": "application/json"
//         }
//     })
//     if (!response.ok) 
//         throw new Error("Error downloading project", response.status)

//     const json = await response.json()
//     return json
// }

// const createProject = async (data) => {
//     const dataClone = { ...data }
//     for (let value in dataClone) { 
//         if (dataClone[value] === true) dataClone[value] = "Si"
//         if (dataClone[value] === false) dataClone[value] = "No"
//         if (dataClone[value] === null) delete dataClone[value]
//     }

//     const response = await fetch("https://greenovationdashboard.azurewebsites.net/api/enelcore", {
//         method: "POST",
//         body: JSON.stringify(dataClone),
//         headers: {
//             "Content-Type": "application/json"
//         }
//     })
//     if (!response.ok) 
//         throw new Error("Error creating project", response.status)

//     return await response.json()
// }

const checkCAP = async (data) => {
    return true;
}

const sendProject = async (data) => {
    const dataClone = { ...data }
    for (let value in dataClone) { 
        if (value === "negozi") continue;
        if (dataClone[value] === true) dataClone[value] = "Si"
        if (dataClone[value] === false) dataClone[value] = "No"
        if (dataClone[value] === null) delete dataClone[value]
    }

    const response = await fetch("https://greenovationdashboard.azurewebsites.net/api/enelitcore", {
        method: "POST",
        body: JSON.stringify(dataClone),
        headers: {
            "Content-Type": "application/json"
        }
    })
    if (!response.ok) 
        throw new Error("Error creating project", response.status)

    return await response.json()
}

const sendProjectFinal = async (data) => {
    const dataClone = { ...data }
    
    if (data["PresenzaBalcone"] === undefined)
        dataClone["PresenzaBalcone"] = false
    
    if (data["User_Foto"] === "C53"){
        dataClone["C53"] = true
        dataClone["C54"] = false
    }
    else if (data["User_Foto"] === "C54"){
        dataClone["C53"] = false
        dataClone["C54"] = true
    }

    if (data["NumeroClimatizzatori"] === undefined || data["NumeroClimatizzatori"] === false || data["NumeroClimatizzatori"] === "No") 
        dataClone["NumeroClimatizzatori"] = Math.min(parseInt(data["C16"]), 9)

    if (dataClone["C42"] === null || dataClone["C42"] === undefined){
        dataClone["C42"] = optionsAi.find(item => item.N == dataClone["NumeroClimatizzatori"])?.macchine
    } 
    else {
        dataClone["C42"] = optionsAi.find(item => item.name === dataClone["C42"])?.macchine
    }
    dataClone["D48"] = dataClone["D48_val"]
    // debugger
    for (let value in dataClone) { 
        if (value === "negozi") continue;
        if (dataClone[value] === true) dataClone[value] = "Si"
        if (dataClone[value] === false) dataClone[value] = "No"
        if (dataClone[value] === null) delete dataClone[value]
    }

    dataClone.PreviousEnelCoreModelId = dataClone.EnelCoreModelId
    delete dataClone.EnelCoreModelId

    const response = await fetch("https://greenovationdashboard.azurewebsites.net/api/enelitcorefinal", {
        method: "POST",
        body: JSON.stringify(dataClone),
        headers: {
            "Content-Type": "application/json"
        }
    })
    if (!response.ok) 
        throw new Error("Error creating project", response.status)

    return await response.json()
}

const sendLead = async (data) => {
    // data.prd = process.env.REACT_APP_ENV
    const response = await fetch("https://greenovationdashboard.azurewebsites.net/api/enelcorelead", {
        method: "POST",
        body: JSON.stringify({...data, prd: process.env.REACT_APP_ENV, isEnelIT: true}),
        headers: {
            "Content-Type": "application/json"
        }
    })
    if (!response.ok) 
        throw new Error("Error creating project", response.status)

    return await response.json()
}


const exportedFunctions =  {
    sendProjectFinal,
    testRendering,
    checkCAP,
    // checkIfProjectIsComplete,
    sendProject,
    sendLead,
    sendFoto
}

export default exportedFunctions